module.exports = __webpack_public_path__ + "media/images/icons/robot-c2a79f30547ba2c0614c53369632f3e7.svg";